module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "intro-to-ghg-center--cover.ec6b150b.png";